/**
 * StartPointModal - Modal for setting installer's starting point for a specific day
 * Extracted from CalendarPage.js for better maintainability
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

const StartPointModal = ({ installer, date, currentOverride, onClose, onSave }) => {
  const { t, i18n } = useTranslation();
  const [mode, setMode] = useState(currentOverride ? 'custom' : 'home');
  const [customAddress, setCustomAddress] = useState(currentOverride || '');

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="start-point-modal"
    >
      <div 
        className="bg-white rounded-xl shadow-2xl w-full max-w-md"
        onClick={e => e.stopPropagation()}
      >
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-bold text-gray-800">{t('calendar.startingPoint')}</h3>
          <button 
            onClick={onClose} 
            className="p-2 hover:bg-gray-100 rounded-lg"
            data-testid="close-start-point-modal"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="p-4 space-y-4">
          <p className="text-sm text-gray-600">
            {installer.first_name} {installer.last_name} - {date.toLocaleDateString(i18n.language)}
          </p>

          <div className="space-y-3">
            <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input
                type="radio"
                name="startPoint"
                checked={mode === 'home'}
                onChange={() => setMode('home')}
                className="mt-1"
                data-testid="home-address-radio"
              />
              <div>
                <p className="font-medium text-gray-800">{t('calendar.homeAddress')}</p>
                <p className="text-sm text-gray-500">{installer.starting_address || 'Non impostato'}</p>
              </div>
            </label>

            <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input
                type="radio"
                name="startPoint"
                checked={mode === 'custom'}
                onChange={() => setMode('custom')}
                className="mt-1"
                data-testid="custom-address-radio"
              />
              <div className="flex-1">
                <p className="font-medium text-gray-800">{t('calendar.customAddress')}</p>
                {mode === 'custom' && (
                  <input
                    type="text"
                    value={customAddress}
                    onChange={(e) => setCustomAddress(e.target.value)}
                    placeholder="Es: Via Roma 10, Milano"
                    className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    autoFocus
                    data-testid="custom-address-input"
                  />
                )}
              </div>
            </label>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              data-testid="cancel-start-point"
            >
              {t('common.cancel')}
            </button>
            <button
              onClick={() => onSave(mode === 'home' ? null : customAddress)}
              className="flex-1 px-4 py-2 bg-lojack-red text-white rounded-lg hover:bg-red-700"
              data-testid="save-start-point"
            >
              {t('calendar.saveForToday')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPointModal;
